export enum PricingItemType {
    TAXABLE_MILES = 'TAXABLE_MILES',
    FUEL_TAX_CREDIT = 'FUEL_TAX_CREDIT',
}
